import { useState } from 'react';
import { api, type Membership, type Rank } from '../lib/api';
import { liffOpenExternal } from '../lib/liff';

const RANKS: Array<{ key: Rank; label: string; price: string; desc: string; sub?: string }> = [
  {
    key: 'standard',
    label: 'STANDARD',
    price: '¥3,000 / 月',
    desc: '来店時ウェルカムドリンク1杯（月2回まで）',
    sub: 'スタンダードメニュー表の中からお選びいただけます',
  },
  {
    key: 'high_class',
    label: 'PREMIUM',
    price: '¥10,000 / 月',
    desc: '来店毎にウェルカムドリンク1杯（回数無制限）',
    sub: 'スタンダードメニュー表の中からお選びいただけます',
  },
];

const STATUS_TEXT: Record<string, string> = {
  pending: '入会手続きを完了してください。',
  past_due: 'お支払いに失敗しています。カード情報をご確認ください。',
  canceled: 'サブスクリプションは解約されています。再加入できます。',
};

export function Subscribe({
  member,
  onSubscribed,
}: {
  member: Membership;
  onSubscribed: () => Promise<void>;
}) {
  const [busy, setBusy] = useState<Rank | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function handleSubscribe(rank: Rank) {
    setBusy(rank);
    setError(null);
    try {
      const r = await api.checkout(rank, window.location.href);
      liffOpenExternal(r.url);
      // 戻り後の状態反映は別途。手動更新ボタンを置く。
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(null);
    }
  }

  return (
    <>
      <div className="card">
        <div style={{ fontSize: 18 }}>{member.displayName ?? 'ようこそ'}</div>
        <div className="muted" style={{ marginTop: 8 }}>
          {STATUS_TEXT[member.status] ?? '会員プランを選択してください。'}
        </div>
      </div>

      {RANKS.map((r) => (
        <div className="card" key={r.key}>
          <div className={`rank-${r.key}`} style={{ fontSize: 18, letterSpacing: '0.15em' }}>
            {r.label}
          </div>
          <div style={{ marginTop: 8, fontSize: 20 }}>{r.price}</div>
          <div style={{ marginTop: 12 }}>{r.desc}</div>
          {r.sub && (
            <div className="muted" style={{ marginTop: 6, fontSize: 12 }}>{r.sub}</div>
          )}
          <button
            className="primary"
            disabled={busy !== null}
            onClick={() => void handleSubscribe(r.key)}
          >
            {busy === r.key ? '処理中…' : '加入する'}
          </button>
        </div>
      ))}

      <div className="card">
        <div className="muted" style={{ marginBottom: 4 }}>スタンダードメニュー表</div>
        <a
          href="/menu.html"
          target="_blank"
          rel="noreferrer"
          style={{ color: '#d4af37', textDecoration: 'none' }}
        >
          メニュー表を見る →
        </a>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="card">
        <div className="muted">支払い完了後、こちらを押して反映してください。</div>
        <button onClick={() => void onSubscribed()}>状態を更新</button>
      </div>
    </>
  );
}
